import { useState, useEffect } from "react"
import Axios from "../../AxiosConfig";
import { useNavigate } from "react-router-dom";
const initialStats = [
    { name: 'Total Employees', value: 0 },
    { name: 'Employees Present Today', value: 0 },
    { name: 'Leaves Pending Action', value: 0 },
    { name: 'Unresolved Communications', value: 0 },
]

const navigationUrl = [
    "/employees",
    "/attendance",
    "/leaves",
    "/communication"
]

export default function Stats() {
    const [stats, setStats] = useState(initialStats)
    const navigate = useNavigate();
    useEffect(() => {
        Axios.post("/overview/stats")
            .then((res) => {
                // Filter out the unwanted stats
                const filteredStats = res.data.stats.filter(stat => 
                    stat.name !== 'Total Active Employees' && 
                    stat.name !== 'Total Inactive Employees'
                );
                setStats(filteredStats);
                // setStats(res.data.stats)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    return (
        <dl className="mx-auto grid grid-cols-1 gap-px bg-gray-900/5 sm:grid-cols-2 lg:grid-cols-4">
            {stats.map((stat, index) => (
                <div
                    key={stat.name}
                    onClick={() => { navigate(navigationUrl[index]) }}
                    className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 bg-white px-4 py-10 sm:px-6 xl:px-8 cursor-pointer hover:bg-gray-100/50"
                >
                    <dt className="text-sm font-medium leading-6 text-gray-500">{stat.name}</dt>
                    <dd className="w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900">
                        {stat.value}
                    </dd>
                </div>
            ))}
        </dl>
    )
}
